import { ExternalLink } from "lucide-react"

import { CopyButton } from "@/components/CopyButton"
import { SeoHead } from "@/components/SeoHead"
import { Card, CardContent } from "@/components/ui/card"

/**
 * A coach's share links, embedded in the KF CRM left menu (task #557).
 *
 * No site header or footer: KF CRM wraps this page in its own chrome, and the
 * page must fit its iframe. `found` is false when the page was opened without a
 * KF CRM sub-account — the old dashboard link that Cloudflare redirects here.
 */
export default function HelpfulLinks({ seo, found = false, coachName = null, links = [], micrositeMissing = false }) {
  return (
    <>
      <SeoHead seo={seo}>
        <meta name="robots" content="noindex, nofollow" />
      </SeoHead>
      <main className="min-h-screen bg-zinc-50 px-4 py-8 text-zinc-900">
        <div className="mx-auto max-w-3xl">
          <h1 className="font-display text-3xl uppercase tracking-wide">Helpful Links</h1>

          {found ? (
            <>
              {coachName && <p className="mt-1 text-zinc-600">{coachName}</p>}

              {micrositeMissing && (
                <p className="mt-4 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
                  Some of your links are missing because your microsite link is not set in KF CRM. Ask Jen to add
                  the <strong>Microsite Link</strong> custom value to your account.
                </p>
              )}

              <ul className="mt-6 space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Card className="py-0">
                      <CardContent className="flex flex-col gap-2 p-4 sm:flex-row sm:items-center sm:justify-between">
                        <div className="min-w-0">
                          <p className="font-medium">{link.label}</p>
                          <a
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex max-w-full items-center gap-1 break-all font-mono text-xs text-kf-red hover:underline"
                          >
                            {link.url}
                            <ExternalLink className="h-3 w-3 shrink-0" />
                          </a>
                        </div>
                        <CopyButton text={link.url} label="Copy link" />
                      </CardContent>
                    </Card>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <Card className="mt-6">
              <CardContent className="p-6">
                <p className="text-lg font-medium">Helpful Links has moved.</p>
                <p className="mt-2 text-zinc-600">
                  Open <strong>Helpful Links</strong> from the left menu in KF CRM to see your links.
                </p>
              </CardContent>
            </Card>
          )}
        </div>
      </main>
    </>
  )
}
